module.exports = __webpack_public_path__ + "img/image-to-video.fddecb48.svg";